<template>
    <div class="container-fluid">
        <section v-show="efitment.eObjectType !== 'NotReady'">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    <div class="pull-left">
                                        <h4 class="card-title float-left" v-if="efitment.id">
                                            {{$t("fitment.label")}}</h4>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="alert-warning" v-if="efitment.eObjectType=='Waiting'">
                                        <button class="close" data-dismiss="alert">
                                            ×
                                        </button>
                                        <i class="fa-fw fa fa-warning mr-1"></i>
                                        <strong>Янги!</strong> Хали кўрилмади.
                                    </div>

                                    <div class="alert-info" v-if="efitment.eObjectType=='Inprogress'">
                                        <button class="close" data-dismiss="alert">
                                            ×
                                        </button>
                                        <i class="fa-fw fa fa-info"></i>
                                        <strong>Жараён кетяпти!</strong> Кўриб чиқиляпти.
                                    </div>

                                    <div class="alert-success" v-if="efitment.eObjectType=='Done'">
                                        <button class="close" data-dismiss="alert">
                                            ×
                                        </button>
                                        <i class="fa-fw fa fa-check"></i>
                                        <strong>Муаффақиятли баҳоланган!</strong> Тамом.
                                    </div>

                                    <div class="alert-danger" v-if="efitment.eObjectType=='Reject'">
                                        <button class="close" data-dismiss="alert">
                                            ×
                                        </button>
                                        <i class="fa-fw fa fa-times"></i>
                                        <strong>Бекор қилинган!</strong> Бекор қилинган.
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <button class="all-btn add-btn"
                                            v-if="efitment.eObjectType === 'Waiting' && hasPermission('E_BAHOLASH_FITMENTS_BIND_APPRAISER')"
                                            @click="applyAppraisal()">
                                        <i class="fa fa-check"></i>
                                        {{$t("realEstate.action.bindAppraiser")}}
                                    </button>

                                    <button class="all-btn delete-btn ml-2"
                                            v-if="efitment.eObjectType === 'Waiting' && hasPermission('E_BAHOLASH_FITMENTS_REJECT')"
                                            @click="showReject">
                                        <i class="fa fa-reply"></i>
                                        {{$t("realEstate.action.pending")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.ownerClient")}}</label>
                                        <div class="form-control">
                                            <div v-if="efitment && efitment.ownerClient">
                                                <strong>{{ efitment.ownerClient.fullName }}</strong>
                                                <span> - {{ efitment.ownerClient.firmName }} </span>
                                                <span class="badge badge-primary"
                                                      v-if="efitment.ownerClient.type === 'Legal'"> Юридик шахс</span>
                                                <span class="badge badge-primary" v-else> Жисмоний шахс</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.name")}}</label>
                                        <div class="form-control">
                                            <span>{{ efitment.name }}</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.evaluationPurpose")}}</label>
                                        <div class="form-control">
                                            <div v-if="efitment.evlGoalType === 'Predge'">Гаровга қўйиш</div>
                                            <div v-else-if="efitment.evlGoalType === 'Sale'">Сотиш учун</div>
                                            <div v-else-if="efitment.evlGoalType === 'Zero'">0 кийматда хусусийлаштириш
                                            </div>
                                            <div v-else-if="efitment.evlGoalType === 'DeterminingValue'">Бозор қийматини
                                                аниқлаш
                                            </div>
                                            <div v-else-if="efitment.evlGoalType === 'Investment'">Инвестиция қийматини
                                                аниқлаш
                                            </div>
                                            <div v-else-if="efitment.evlGoalType === 'Privatization'">Хусусийлаштириш</div>
                                            <div v-else-if="efitment.evlGoalType === 'FormationStatutoryFund'">Устав
                                                жамғармасини шакллантириш
                                            </div>
                                            <div v-else-if="efitment.evlGoalType === 'BusinessDeterminingValue'">Бизнес
                                                қийматини аниқлаш
                                            </div>
                                            <div v-else-if="efitment.evlGoalType === 'AcceptToBalance'">Балансга кабул
                                                килиш
                                            </div>
                                            <div v-else-if="efitment.evlGoalType === 'Losses'">Етказилган зарар(сотиш)
                                            </div>
                                            <div v-else-if="efitment.evlGoalType === 'DeterminationValue'">Қийматини аниқлаш
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="efitment.eObjectType=='Reject'" class="form-group">
                                        <label>{{$t("realEstate.field.rejectText")}}</label>
                                        <div class="form-control h-100">
                                            <div v-if="efitment && efitment.reasonDesc">
                                                {{ efitment.reasonDesc }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class=" col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.propertyType")}}</label>
                                        <div class="form-control">
                                            <div v-if="efitment.evlPropertyType === 'Private'">Хусусий мулк</div>
                                            <div v-else-if="efitment.evlPropertyType === 'Government'">Давлат мулки</div>
                                            <div v-else-if="efitment.evlPropertyType === 'Society'">Жамият мулки</div>
                                            <div v-else>Жамоа мулки</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.createdDate")}}</label>
                                        <div class="form-control">{{ new Date(efitment.createDate) |
                                            dateFormat('DD.MM.YYYY') }}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.createdBy")}}</label>
                                        <div class="form-control">
                                            <div v-if="efitment && efitment.createUserName && efitment.createUserName">
                                                {{ efitment.createUserName }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.contractAmount")}}</label>
                                        <numeric-input v-model="efitment.evlContractAmount"
                                                       :controls="false" :precision="2"
                                                       :min="120000"
                                        >
                                        </numeric-input>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="section-header">
                                        <h4>Автотранспортларни бахолаш учун тақдим қилинган хужжатлар</h4>
                                    </div>
                                </div>
                                <template>
                                    <PreviewDropZone
                                            code="documentsDropZone"
                                            label="Мурожат хати ёки Паспорт нусхаси"
                                            :data="efitment.letterFiles"
                                            @change="(files) => {efitment.letterFiles = files}"
                                    />

                                    <template v-if="isOwnerTypeLegal && isOrgTypeMib">
                                        <PreviewDropZone
                                                code="actOfSaleDropZone"
                                                label="realEstate.field.docActOfSale"
                                                :data="efitment.actOfSaleFiles"
                                                @change="(files) => {efitment.actOfSaleFiles = files}"
                                        />
                                        <PreviewDropZone
                                                code="decisionDropZone"
                                                label="realEstate.field.docDecision"
                                                :data="efitment.decisionFiles"
                                                @change="(files) => {efitment.decisionFiles = files}"
                                        />
                                        <PreviewDropZone
                                                code="playlistDropZone"
                                                label="realEstate.field.docPlaylist"
                                                :data="efitment.executivePlaylistFiles"
                                                @change="(files) => {efitment.executivePlaylistFiles = files}"
                                        />
                                    </template>
                                </template>
                            </div>
                            <div class="row" v-if="efitment.id && efitment.id > 0">
                                <div class="col-12">
                                    <div class="section-header">Асосий воситалар</div>
                                    <div v-for="(fitment, fitmentIndex) in efitment.eFitmentDtoList" :key="fitment.id">
                                        <div class="section-header">{{ fitmentIndex + 1}} - асосий восита
                                            маълумотлари
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{$t("fitment.name")}}</label>
                                                <div>№ {{fitmentIndex + 1}}. {{ fitment.name }}</div>
                                            </div>
                                        </div>
                                        <PreviewDropZoneEAppraisal
                                                code="texPassportDropZone"
                                                label="fitment.texPassport"
                                                :data="fitment.fitmentTexPassports"
                                                @change="(texPassportFiles) => {fitment.fitmentTexPassports = texPassportFiles}"
                                        />
                                        <PreviewDropZoneEAppraisal
                                                code="fitmentPhotoDropZone"
                                                label="fitment.photos"
                                                :data="fitment.fitmentPictures"
                                                @change="(fitmentPhotos) => {fitment.fitmentPictures = fitmentPhotos}"
                                        />
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{$t("building.field.description")}}</label>
                                                <div class="form-control">{{ fitment.aboutFitment }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template>
                <b-modal v-model="show" title="Кўчмас мулкни бекор қилиш">
                    <div class="container-fluid">
                        <div class="form-group">
                            <label>Бекор қилиш сабабини киритинг<span class="red">*</span></label>
                            <textarea class="form-control"
                                      v-model="efitment.reasonDesc">
                        </textarea>
                        </div>
                    </div>
                    <div slot="modal-footer">
                        <button
                                type="button"
                                class="all-btn add-btn float-right ml-2"
                                @click="rejectAppraisal()"
                        >{{$t("action.save")}}
                        </button>
                        <button
                                type="button"
                                class="all-btn delete-btn float-right"
                                @click="rejectModalHide"
                        >{{$t("action.cancel")}}
                        </button>
                    </div>
                </b-modal>
            </template>
        </section>
        <section v-show="efitment.eObjectType === 'NotReady'">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    <button class="all-btn add-btn"
                                            v-if="!createUser || createUser.id"
                                            @click="bindAgent"
                                    >
                                        <i class="fa fa-check"></i>
                                        {{$t("realEstate.action.bindAgent")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>{{$t("report.field.agents")}}</label>
                                        <v-select v-model="createUser" label="text"
                                                  :options="agents"
                                                  :filterable="false"
                                                  @search="onUsersSearch"
                                                  @search:focus="onUsersFocus">
                                            <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.name"></div>
                                            </template>
                                            <template slot="selected-option"
                                                      v-if="createUser && createUser.name">
                                                <div v-html="createUser.name"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                        <div class="red" v-if="$v.createUser.$error">
                                            {{$t("realEstate.field.agent")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.address")}}</label>
                                        <div class="form-control">
                                            <div v-if="efitment.ownerClient && efitment.ownerClient.address">
                                                <strong>{{ efitment.ownerClient.address }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("finance.field.phoneNumber")}}</label>
                                        <div class="form-control">
                                            <div v-if="efitment && efitment.apiOrderDto">
                                                <strong>{{ efitment.apiOrderDto.mobilePhone }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

    import PreviewDropZoneEAppraisal from "@/views/real-estate/PreviewDropZoneEAppraisal";
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import initFilterModel from '@/shared/filter';
    import {requiredUnless} from 'vuelidate/lib/validators';

    export default {
        name: "EFitmentView",
        components: {
            PreviewDropZone,
            PreviewDropZoneEAppraisal,
            'b-modal': bModal
        },
        data() {
            return {
                processing: false,
                show: false,
                efitment: {
                    reasonDesc: '',
                    evlContractAmount: 0
                },
                filter: initFilterModel(),
                agents: [],
                createUser: {}
            }
        },
        validations() {
            return {
                createUser: {
                    required: requiredUnless(() => {
                        return !(this.efitment.eObjectType === 'NotReady');
                    })
                }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;
                if (id && id > 0) {
                    this.$http.get('/e-appraisal/fitment/' + id)
                        .then(res => {
                            vm.efitment = res.data;
                            vm.createUser = {
                                id: res.createUserId
                            };
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.fixedExpense.error'),
                                type: 'error'
                            });
                            this.processing = false;
                        })

                }
            },
            applyAppraisal() {
                const vm = this;
                vm.processing = true;
                this.$http.get('e-appraisal/fitment/assigned-appraisal/' + vm.efitment.id)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$router.push('/e-appraisal/fitment/list');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.common.errorOccurred'),
                                type: 'warning'
                            });
                        }
                        vm.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.common.errorOccurred'),
                            type: 'error'
                        });
                        vm.processing = false;
                    })
            },
            rejectAppraisal() {
                if (this.efitment.reasonDesc) {
                    this.processing = true;
                    const data = {
                        rejectObjectId: this.efitment.id,
                        comment: this.efitment.reasonDesc
                    };
                    this.$http.post('e-appraisal/fitment/status/reject', data)
                        .then(res => {
                            if (res && res.data && res.data.status === 'SUCCESS') {
                                this.$router.push('/e-appraisal/fitment/list');
                            } else {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.$t('asset.statusWarning'),
                                    type: 'warning'
                                });
                            }
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('asset.statusError'),
                                type: 'error'
                            });
                            this.processing = false;
                        })
                } else {
                    this.$swal({
                        title: 'Хабар!',
                        text: 'Бекор қилиш сабабини киритинг!',
                        type: 'warning'
                    });
                }
            },
            showReject() {
                this.efitment.reasonDesc = '';
                this.show = true;
            },
            rejectModalHide() {
                this.show = false;
            },
            onUsersSearch(searchTxt, loading) {
                loading(true);
                this.agents = [];
                this.filter.search = searchTxt;
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                        loading(false);
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onUsersFocus() {
                this.agents = [];
                this.filter.search = '';
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            bindAgent() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;

                if (this.createUser) {
                    this.efitment.createUserId = this.createUser.id
                }

                this.$http.post('e-appraisal/fitment/bind-agent', this.efitment).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.fitment.statusSuccess'),
                            type: 'success'
                        });
                        this.$router.push('/e-appraisal/fitment/list');
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t(res.data.message),
                            type: 'warning'
                        });
                    }
                    this.processing = false;
                }, () => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('messages.fitment.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                })
            }
        },
        created() {
            this.filter.province = null;
            this.init();
        },
        computed: {
            isOwnerTypeLegal() {
                return !!(this.efitment.ownerClient && this.efitment.ownerClient.type && this.efitment.ownerClient.type === 'Legal');
            },
            isOrgTypeMib() {
                return !!(this.efitment.ownerClient && this.efitment.ownerClient.organizationType &&
                    (this.efitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.efitment.ownerClient.organizationType === 'CUSTOMS_ADMINISTRATION'));
            }
        }
    }
</script>

<style scoped>

</style>